import PropTypes from "prop-types";

function NextArrow(props) {
  const { className, customClassName, style, onClick } = props;
  return (
    <div className={`${className} ${customClassName}`} style={{ ...style }} onClick={onClick} />
  );
}

export default NextArrow;

NextArrow.propTypes = {
  className: PropTypes.string,
  customClassName: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};
